import React from 'react';
import TopBarFornecedor from '../TopBar/TopBarFornecedor';
import './Layout.css';
import { Outlet } from 'react-router-dom';

export default function LayoutFornecedor() {
  return (
    <div className="layout-container">
      <TopBarFornecedor />
      <div className="layout-content">
        <Outlet />
      </div>
    </div>
  );
} 